// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout-container {
  display: flex;
  height: 100%;
}

/* LEFT SIDE */
.left-side {
  width: 15%;
  background-color:var(--sidebar-color);
  color: white;
  transition: width 0.3s ease;
  padding-top: 15px;
  box-sizing: border-box;
}

.left-side.collapsed {
  width:4%;
}

/* HEADER */
.sidebar-header {
  display: flex;
  justify-content:center;
  align-items: center;
  gap: 40px;
  margin-bottom: 50px;
}

.sidebar-title ,.color{
    margin: 0;
    color: var(--selecte-row-color);
    text-shadow: 0 0 var(--selecte-row-color);
}


.toggle-btn {
  background: none;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
  margin-left: 5px;
}

/* RIGHT SIDE */
.right-side {
  width: 85%;
  background-color:var(--screen-color);
  box-sizing:border-box;
  padding: 10px;
  overflow:hidden;
}

.right-side.grow{
    width:95% ;
}

.right-side-ori{
    width: 80%;
}

.sidebar-content{
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-left: 15px;
    gap: 15px;
}

.sidebar-link {
  display: flex;
  color: #e5e7eb;
  border-radius: 6px;
  text-decoration: none;
  transition: all 0.2s ease, color 0.2s ease;
  min-width: 70%;
  width: max-content;
  gap:10px;
  align-items: center;
  opacity:0.5 ;
  height:40px;
  padding-right: 5px;
  padding-left: 5px;
}

.sidebar-link.link-col{
    padding: 2px;
    padding-top:10px ;
    padding-bottom: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* Hover */
.sidebar-link:hover {
  background-color: var(--selecte-row-color);
  color: #ffffff;
   outline: 2px solid rgba(255, 255, 255, 0.842);
   opacity: 1;
   scale: 1.1;
}

/* Active route */
.sidebar-link.active {
  background-color: var(--selecte-row-color);
  color: white;
}

/* Focus */
.sidebar-link:focus {
  outline: 2px solid var(--selecte-row-color);
  outline-offset: 2px;
}


.link-active{
  opacity: 1;
  outline: 2px solid var(--selecte-row-color);
}

`, "",{"version":3,"sources":["webpack://./src/components/layout/layout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;AACd;;AAEA,cAAc;AACd;EACE,UAAU;EACV,qCAAqC;EACrC,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,QAAQ;AACV;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;IACI,SAAS;IACT,+BAA+B;IAC/B,yCAAyC;AAC7C;;;AAGA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,UAAU;EACV,oCAAoC;EACpC,qBAAqB;EACrB,aAAa;EACb,eAAe;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,UAAU;AACV;EACE,0CAA0C;EAC1C,cAAc;GACb,6CAA6C;GAC7C,UAAU;GACV,UAAU;AACb;;AAEA,iBAAiB;AACjB;EACE,0CAA0C;EAC1C,YAAY;AACd;;AAEA,UAAU;AACV;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;;AAGA;EACE,UAAU;EACV,2CAA2C;AAC7C","sourcesContent":[".layout-container {\n  display: flex;\n  height: 100%;\n}\n\n/* LEFT SIDE */\n.left-side {\n  width: 15%;\n  background-color:var(--sidebar-color);\n  color: white;\n  transition: width 0.3s ease;\n  padding-top: 15px;\n  box-sizing: border-box;\n}\n\n.left-side.collapsed {\n  width:4%;\n}\n\n/* HEADER */\n.sidebar-header {\n  display: flex;\n  justify-content:center;\n  align-items: center;\n  gap: 40px;\n  margin-bottom: 50px;\n}\n\n.sidebar-title ,.color{\n    margin: 0;\n    color: var(--selecte-row-color);\n    text-shadow: 0 0 var(--selecte-row-color);\n}\n\n\n.toggle-btn {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 18px;\n  cursor: pointer;\n  margin-left: 5px;\n}\n\n/* RIGHT SIDE */\n.right-side {\n  width: 85%;\n  background-color:var(--screen-color);\n  box-sizing:border-box;\n  padding: 10px;\n  overflow:hidden;\n}\n\n.right-side.grow{\n    width:95% ;\n}\n\n.right-side-ori{\n    width: 80%;\n}\n\n.sidebar-content{\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    padding-left: 15px;\n    gap: 15px;\n}\n\n.sidebar-link {\n  display: flex;\n  color: #e5e7eb;\n  border-radius: 6px;\n  text-decoration: none;\n  transition: all 0.2s ease, color 0.2s ease;\n  min-width: 70%;\n  width: max-content;\n  gap:10px;\n  align-items: center;\n  opacity:0.5 ;\n  height:40px;\n  padding-right: 5px;\n  padding-left: 5px;\n}\n\n.sidebar-link.link-col{\n    padding: 2px;\n    padding-top:10px ;\n    padding-bottom: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n/* Hover */\n.sidebar-link:hover {\n  background-color: var(--selecte-row-color);\n  color: #ffffff;\n   outline: 2px solid rgba(255, 255, 255, 0.842);\n   opacity: 1;\n   scale: 1.1;\n}\n\n/* Active route */\n.sidebar-link.active {\n  background-color: var(--selecte-row-color);\n  color: white;\n}\n\n/* Focus */\n.sidebar-link:focus {\n  outline: 2px solid var(--selecte-row-color);\n  outline-offset: 2px;\n}\n\n\n.link-active{\n  opacity: 1;\n  outline: 2px solid var(--selecte-row-color);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
